var contentListAjax = false;

var initializeContentListBlock = function(block){
	
	var blockID = block.hasClass("acf-block-preview") ? jQuery(".wp-block-content-list", block).attr("ID") : block.attr("id");
	var contentAjax = false;
	var ajaxLoads = 0;
	
	// Allows image to load in preview window when vars aren't defined
	if(typeof contentArgs === 'undefined') {
		return false;
	}
	
	var postType = contentArgs[blockID].postType;
	var count = parseInt(contentArgs[blockID].count);
	var offset = parseInt(contentArgs[blockID].offset);
	var terms = contentArgs[blockID].terms;
	var search = contentArgs[blockID].search;
	var otherArgs = contentArgs[blockID].otherArgs;
	var button = jQuery(".load-more-content", block);
	var holder = jQuery(".posts", block);
	var paginationHolder = jQuery(".pagination-holder", block);
	var pagination = paginationHolder ? true : false;
	
	// Load more button
	button.on('click', function(){
	
		if(contentListAjax) {
			return false;
		}
	
		offset = count + (ajaxLoads * count);
	
		block.addClass('content-loading');
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs,
			success:function(results){
				
				var returnData = JSON.parse(results);
	
				holder.append(returnData["content-items"]);
				block.removeClass('content-loading');
				
				if(!returnData["remaining-posts"]) {
					button.hide();
				}
	
				ajaxLoads++;
	
				contentListAjax = false;
	
			}
		});
	
	});
	
	// Pagination
	jQuery(block).on("click", ".pagination a[data-page]", function(){
		
		var link = jQuery(this);
		var page = link.attr("data-page");
		
		if(contentListAjax) {
			return false;
		}
		
		offset = (page-1) * count;
		search = jQuery(".plumb-content-search", block).length ? jQuery(".plumb-content-search", block).val() : "";
		terms = gatherSelectedTerms(block);
		
		block.addClass('content-loading');
		
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + page,
			success:function(results){
				
				var returnData = JSON.parse(results);
		
				holder.html(returnData["content-items"]);
				paginationHolder.html(returnData["pagination"]);
				block.removeClass('content-loading');
		
				contentListAjax = false;
		
			}
		});
		
	});
	
	// Term check list
	jQuery('.content-filter', block).on('change', function(e){
	
		e.preventDefault();
		
		if(contentListAjax) {
			return false;
		}
	
		offset = 0;
		ajaxLoads = 0;
		search = '';
		terms = gatherSelectedTerms(block);
	
		block.addClass('content-loading');
		
		jQuery('.plumb-content-search', block).val("");
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + 1,
			success:function(results){
				
				var returnData = JSON.parse(results);
				
				holder.html(returnData["content-items"]);
				block.removeClass('content-loading');
				
				if(pagination) {
					paginationHolder.html(returnData["pagination"]);
				}
				
				if(!returnData["remaining-posts"]) {
					button.hide();
				} else {
					button.show();
				}
	
				contentListAjax = false;
				
				adjustURL(block);
	
			}
		});
	
	});
	
	// Search
	jQuery('.plumb-content-search-form', block).on('submit', function(e){
		
		e.preventDefault();
		
		if(contentListAjax) {
			return false;
		}
	
		offset = 0;
		ajaxLoads = 0;
		search = jQuery('.plumb-content-search', block).val();
	
		resetTerms();
	
		jQuery('html').addClass('content-loading');
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + 1,
			success:function(results){
				
				var returnData = JSON.parse(results);
	
				holder.html(returnData["content-items"]);
				
				if(pagination) {
					paginationHolder.html(returnData["pagination"]);
				}
				
				block.removeClass('content-loading');
	
				contentListAjax = false;
				
				adjustURL(block);
	
			}
		});
	
	});
	
}

function gatherSelectedTerms(block) {
	
	var terms = [];

	jQuery('.content-filter', block).each(function(){

		var current = jQuery(this);
		var taxonomy = current.attr('data-tax');
		var value = current.val();
		var obj = {};

		if(value) {
			obj[taxonomy] = value;
			terms.push(obj);
		}

	});

	return JSON.stringify(terms);

}

function resetTerms() {

	jQuery('.content-filter').each(function(){
		jQuery("option:first-child", this).prop('selected', true);
	});

}

function adjustURL(block) {
	
	var terms = gatherSelectedTerms(block);
	var search = jQuery('.plumb-content-search', block).val();
	var url = new URL(window.location.href);

	if(terms.length > 2) {
		url.searchParams.set('terms', terms);
	} else {
		url.searchParams.delete('terms');
	}
	
	if(search) {
		url.searchParams.set('content-search', search);
	} else {
		url.searchParams.delete('content-search');
	}
	
	history.replaceState({}, "", url);
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-content-list').each(function(){
		initializeContentListBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=content-list', initializeContentListBlock);
